import { ITabsProps } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { selectInfrastructureFromBuilder, selectTransportAccessibility } from 'shared/selectors/transportAccessibility';
import { ETransportAccessibilityTab } from 'shared/types/map';

export const useTransportAccessibilityTabs = () => {
  const transportAccessibility = useSelector(selectTransportAccessibility);
  const infrastructureFromBuilder = useSelector(selectInfrastructureFromBuilder);

  const tabs: ITabsProps['tabs'] = [];

  if (transportAccessibility) {
    tabs.push({
      value: ETransportAccessibilityTab.Outside,
      title: 'Рядом с ЖК',
    });
  }

  if (infrastructureFromBuilder) {
    tabs.push({
      value: ETransportAccessibilityTab.Inside,
      title: 'Внутри ЖК',
    });
  }

  return tabs;
};
